ElecboyTheme.scrollFncs = [];

ElecboyTheme.countdown = function () {
	$('[data-countdown-inline]').each(function() {
    var finalDate = $(this).data('countdown-inline');
    var showTimer = $(this).data('show-timer');
    var finalDateISO = finalDate.replace(' ','T') + ":00";
    var isFuture = (new Date(finalDateISO)).getTime() > (new Date()).getTime();
    if ( showTimer && isFuture) {
      $(this).removeClass('hidden');
      $(this).countdown(finalDate)
        .on('finish.countdown', function(event) {
          $(this).html('');
        })
        .on('update.countdown', function(event) {
          var remainingPrimaryValue = '';
          var remainingPrimaryUnit = '';
          var remainingSecondaryValue = '';
          var remainingSecondaryUnit = '';
          if (event.offset.totalDays > 0) {
            remainingPrimaryValue = event.offset.totalDays.toString();
            remainingPrimaryUnit = window.lang.day;
            remainingSecondaryValue = event.offset.hours.toString();
            remainingSecondaryUnit = window.lang.hour;
          } else if (event.offset.totalHours > 0) {
            remainingPrimaryValue = event.offset.totalHours.toString();
            remainingPrimaryUnit = window.lang.hour;
            remainingSecondaryValue = event.offset.minutes.toString();
            remainingSecondaryUnit = window.lang.min;
          } else if (event.offset.totalMinutes > 0) {
            remainingPrimaryValue = event.offset.totalMinutes.toString();
            remainingPrimaryUnit = window.lang.min;
            remainingSecondaryValue = event.offset.seconds.toString();
            remainingSecondaryUnit = window.lang.sec;
          } else {
            remainingPrimaryValue = '0';
            remainingPrimaryUnit = window.lang.min;
            remainingSecondaryValue = event.offset.seconds.toString();
            remainingSecondaryUnit = window.lang.sec;
          }
          if ($(this).attr('class').includes('product-brick-countdown-wrapper')) { 
            // Product brick
            $(this).html(
              '<div class="product-brick-countdown">'
              + '<div class="product-brick-countdown__countdown">'
              + $(this).data('countdown-txt') + ': ' 
              + remainingPrimaryValue
              + remainingPrimaryUnit
              + remainingSecondaryValue
              + remainingSecondaryUnit
              + '</div>'
              + ($(this).data('quantity-txt') && 
              '<div class="product-brick-countdown__quantity">'
              + $(this).data('quantity-txt')
              + '</div>')
              + '</div>'
            );
          } else if ($(this).attr('class').includes('product-info-countdown-wrapper')) {
            // Product page
            $(this).find(">:first-child").children().not(':first').remove();
            $(this).find(">:first-child").append(
              '<div class="product-info-countdown__quantity">'
              + $(this).data('quantity-txt')
              + '</div>'
              + '<div class="product-info-countdown__countdown">'
              + '<span class="product-info-countdown__countdown-label">'
              + $(this).data('countdown-txt')
              + '</span>'
              + '<div class="product-info-countdown__countdown-value-wrapper">'
              + '<span class="product-info-countdown__countdown-value">'
              + remainingPrimaryValue
              + '</span>'
              + remainingPrimaryUnit
              + '<span class="product-info-countdown__countdown-value">'
              + remainingSecondaryValue
              + '</span>'
              + remainingSecondaryUnit
              + '</div>'
              + '</div>'
            );
          }
        });
    }
  });
}
ElecboyTheme.clearCartOnLogout = function () {
  $('a[href^="/account/logout"]').on('click', function(event){
    event.preventDefault();
    var href = $(this).attr("href"),
    target = '';

    document.cookie = 'cart=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    // wait for data to push and then open link
    setTimeout(function() { // now wait 150 milliseconds...
      window.open(href,(!target?"_self":target)); // ...and open the link as usual
    },150);

  });
};
ElecboyTheme.showLoggedInMsg = function () {
  if( $('body').data('member') ) {
    // is logged in
    if ( document.referrer.includes('/account/login') ) {
      $('.js-logged-in-msg').removeClass('hide').toggleClass('animate__fadeInUp', true);
      // dismiss the message in 5s
      setTimeout(function(){
        $('.js-logged-in-msg').removeClass('animate__fadeInUp').addClass('animate__fadeOutDown', true);
      },6000);
      // remove the message in 10s
      setTimeout(function(){
        $('.js-logged-in-msg').remove();
      },10000);
    }
  }
};

ElecboyTheme.setupPLPSidebarNav = function () {
  $('.collection-sidebar').on('click', '.plp-sidebar-nav-link .caret', function(e){
    e.preventDefault();
    $(this).parent().toggleClass('is-expanded').siblings().removeClass('is-expanded');
    return false;
  });
};

ElecboyTheme.renderCommentShowcase = function(){
  var $commentCaseWrapper = $('.comment-slides-wrapper');
  $commentCaseWrapper.data('current-idx',0);
  var noOfSlides = $commentCaseWrapper.find('.slide').length;
  setInterval(function(){
    var cs = $commentCaseWrapper.data('current-idx');
    if ( cs < (noOfSlides - 1) ) {
      cs++;
    } else {
      cs = 0;
    }
    $commentCaseWrapper.data('current-idx', cs );
    $commentCaseWrapper.find('.comment-slides').css({
      top: -1*cs*$commentCaseWrapper.height()
    });
  },6000);
  $(window).on('resize', function(){
    $commentCaseWrapper.find('.comment-slides').css({
      top: 0
    });
  })
};

ElecboyTheme.mouseMoveLoc = [];
ElecboyTheme.mouseMoveDoc = function(){
  $(document).on('mousemove', function(e){
    ElecboyTheme.mouseMoveLoc.push({x: e.pageX, y: e.pageY});

    if (ElecboyTheme.mouseMoveLoc.length > 3) {
        ElecboyTheme.mouseMoveLoc.shift();
    }
  });
};

ElecboyTheme.verticalMenu = function(){
  var $mv = $('.main-vertical');
  var $level0 = $mv.find('.level-0');
  $mv.on('mouseenter', '.level-0', function(){
    $(this).addClass('active');
  });
  $mv.on('mouseleave', '.level-0', function(){
    $level0.removeClass('active');
  });
};

ElecboyTheme.stickyHeader = function(){
  var scrollTop,
    $stickyMenu = $('.site-header-container__desktop'),
    stopTop = $('.site-header-container').height();
    // hasOffset = window.pageYOffset !== undefined,
    // docBody   = document.documentElement || document.body.parentNode || document.body;
  ElecboyTheme.scrollFncs.push(function(){
    scrollTop = ElecboyTheme.scrollTop;//hasOffset ? window.pageYOffset : docBody.scrollTop;
    if (scrollTop >= stopTop) {
      // stick the div
      $stickyMenu.parent().addClass('sticky-head');
    } else {
      // release the div
      $stickyMenu.parent().removeClass('sticky-head');
    }
  });
};

ElecboyTheme.copyText = function(val){
  navigator.clipboard.writeText(val);
};

ElecboyTheme.couponReminder = function(){
  $('.coupon-reminder-record').on('change', function(e){
    e.preventDefault();
    var selectedVal = $(this).attr('value');

    var checkboxes = document.querySelectorAll(".coupon-reminder-record");//.checked = false;
    for(const cb of checkboxes) {
      if ( cb.value != selectedVal ) {
        cb.checked = false;
      }
    }
    return false;
  });
  $('.coupon-reminder-cta').on('click', function(e){
    e.preventDefault();
    $('.coupon-reminder').toggleClass('active');
    return false;
  });
  $('.coupon-copy').on('click', function(e){
    e.preventDefault();
    var $this = $(this);
    ElecboyTheme.copyText( $this.data('code') );
    $this.find('img').addClass('active');
    setTimeout(function(){
      $this.find('img').removeClass('active');
    }, 4000);
    return false;
  })
  $('.coupon-reminder-close, .coupon-reminder-head-close').on('click', function(e){
    e.preventDefault();
    $('.coupon-reminder').removeClass('active');
    var checkboxes = document.querySelectorAll(".coupon-reminder-record");//.checked = false;
    for(const cb of checkboxes) {
      cb.checked = false;
    }
    return false;
  });

};

ElecboyTheme.backToTop = function(){
  ElecboyTheme.scrollFncs.push(function(){

    if ( ElecboyTheme.scrollTop === 0) {
      $(".back-to-top").addClass("hidden-top")
    } else {
      $(".back-to-top").removeClass("hidden-top")
    }
  });

  $('.back-to-top').click(function () {
    $('body,html').animate({scrollTop:0}, 1200);
    return false;
  });
}

ElecboyTheme.onScroll = function() {
  var scrollTimer = null;

  $(window).scroll(function () {
    if (scrollTimer) {
        clearTimeout(scrollTimer);   // clear any previous pending timer
    }
    scrollTimer = setTimeout(function(){
      ElecboyTheme.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      for( var fnc of ElecboyTheme.scrollFncs){
        fnc();
      }
    }, 200);   // set new timer
  });
};

ElecboyTheme.stickyElements = function() {
  function fn() {
    $('.sticky').filter(function() {
      if ($(this).css('position') === 'sticky') {
        $(this).css({
          'top': $('.site-header-container').outerHeight() + $('.breadcrumb').outerHeight()
        });
      }
    });
  }
  $(window).resize(fn);
  $(window).trigger('resize');
}

ElecboyTheme.setupPLPSidebarHeight = function() {
  function fn() {
    if ($(window).innerWidth() >= 992) {
      $('.collection-sidebar').css({
        'max-height': 'calc(100vh - ' + ($('.site-header-container').outerHeight() + $('.breadcrumb').outerHeight())+ 'px)',
      });
    } else {
      $('.collection-sidebar').css({
        'max-height': 'inherit',
      });
    }
  }
  $(window).resize(fn);
  $(window).trigger('resize');
}

ElecboyTheme.stickyBreadcrumb = function() {
  function fn() {
    $('#shopify-section-breadcrumbs').css({
      'height': $('.breadcrumb').outerHeight() + 'px',
    });
  }
  $(window).resize(fn);
  $(window).trigger('resize');
}
ElecboyTheme.setupMainContent = function() {
  function fn() {
    $('#MainContent').css({
      'margin-top': $('.site-header-container').outerHeight() + 'px',
    });
  }
  $(window).resize(fn);
  $(window).trigger('resize');
}
ElecboyTheme.initMobileMenu = function () {
  function fn() {
    $('.mob-nav-body, .mobile-submenu').css({
      'height': 'calc( 100% - 49px - ' + $('.mob-nav-header').outerHeight() + 'px)',
    });
  }
  $(window).resize(fn);
  $(window).trigger('resize');

  $('.navbar-button').on('click', function(e){
    $('.mob-content').toggleClass('active');
    $('.mob-screen').addClass('active');
    $('body').addClass('mob-nav-active');
    window.scrollTop = $(document).scrollTop();
    $('html, body').css({'overflow-y': 'hidden'});
  });
  $('.mob-menu-nav').on('click', function(e){
    e.preventDefault();
    $('.mob-nav-body').addClass('hidden is-translucent');
    $target = $(".mobile-submenu[data-menu='"+$(this).data('menu')+"']");
    $target.addClass('is-open');
    setTimeout(function() {
      $target.addClass('is-opaque');
    }, 20);
    return false;
  });
  $('.mobile-submenu-next').on('click', function(e){
    e.preventDefault();
    $(this).parents('.mobile-submenu').removeClass('is-open is-opaque');
    $target = $(".mobile-submenu[data-menu='"+$(this).data('menu')+"']");
    $target.addClass('is-open');
    setTimeout(function() {
      $target.addClass('is-opaque');
    }, 20);
    return false;
  });
  $('.mobile-submenu-back').on('click', function(e){
    e.preventDefault();
    $(this).parents('.mobile-submenu').removeClass('is-open is-opaque');
    $target = $(".mobile-submenu[data-menu='"+$(this).data('menu')+"']");
    if ($target.length > 0) {
      $target.addClass('is-open');
      setTimeout(function() {
        $target.addClass('is-opaque');
      }, 20);
    } else {
      $('.mob-nav-body').removeClass('hidden');
      setTimeout(function() {
        $('.mob-nav-body').removeClass('is-translucent');
      }, 20);
    }
    return false;
  });
}
ElecboyTheme.ecomsendWidget = function() {
  var isInitialized = false;
  setInterval(function() {
    if (!isInitialized) {
      $el = $('#ecomsend-widget');
      if ($el.find('.EcomSendAPP').length > 0) {
        isInitialized = true;
        $el.detach().prependTo("#header");
        $el.css('display', 'block');
        $el.on('resize', function() {
          setTimeout(function() {
            $(window).trigger('resize');
          }, 100);
        });
        setTimeout(function() {
          $el.find('.ecomsend__Popover__Sticky__CloseButton').on('click', function() {
            $el.trigger('resize');
          });
          $el.trigger('resize');
        }, 500);
      }
    }
  }, 500);
}
jQuery(document).ready(function($) {
  ElecboyTheme.verticalMenu();
  ElecboyTheme.setupMainContent();
  ElecboyTheme.setupPLPSidebarNav();
  ElecboyTheme.setupPLPSidebarHeight();
  ElecboyTheme.clearCartOnLogout();
  ElecboyTheme.showLoggedInMsg();
  ElecboyTheme.updateCurrentDateTime();
  ElecboyTheme.renderCommentShowcase();
  ElecboyTheme.mouseMoveDoc();
  ElecboyTheme.onScroll();
  ElecboyTheme.backToTop();
  ElecboyTheme.couponReminder();
  // ElecboyTheme.stickyHeader();
  ElecboyTheme.stickyElements();
  ElecboyTheme.stickyBreadcrumb();
  ElecboyTheme.initMobileMenu();
  ElecboyTheme.countdown();
  ElecboyTheme.ecomsendWidget();
  // Launch Chat for page content
  $(document)
    .on('elecboy-ajax-products', function(e){  // For recently viewed section only
      ElecboyTheme.countdown();
    });

  $('.ssw-page').wrap("<div class='container'></div>");

  $('body').on('click', function(e){
    if ( $(e.target).parents('.cur-question').length == 0 ){
      $('.cur-question').removeClass('is-hover');
      $('.delivery-tooltip div').hide();
    }
  });

	$('.cur-question').on('click', function(e){
    $('.cur-question').removeClass('is-hover');
    $(this).addClass('is-hover');
	});
  $('#btn-collection-copywriting-show-more').on('click', function(e) {
    e.preventDefault();
    const $root = $(this).parents('.collection-copywriting');
    $root.find('.collection-copywriting__excerpt').addClass('hide');
    $root.find('.collection-copywriting__fulltext').removeClass('hide');
  });
  $('#btn-collection-copywriting-show-less').on('click', function(e) {
    e.preventDefault();
    const $root = $(this).parents('.collection-copywriting');
    $root.find('.collection-copywriting__excerpt').removeClass('hide');
    $root.find('.collection-copywriting__fulltext').addClass('hide');
  });
});

